import { useLocation, useNavigate } from "react-router-dom";

import arrow from "../../../../assets/images/icons/arrow.svg";

import './back-btn.css';

export const BackButton = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname === '/search' || location.pathname.includes('/product/') ? "/" : -1;

    const goBack = () => navigate(path);

    return (
        <div className="row mb-3">
            <div className="col d-flex align-items-center back-btn" onClick={goBack}>
                <img src={arrow} alt="назад" />
                <span>Назад</span>
            </div>
        </div>
    )
}